import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ApiErrorSchema } from './user';
const c = initContract();
// Invite User to Workspace DTO
export const InviteUserToWorkspaceSchema = z.object({
    email: z.string().email(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
});
// Invite Response DTO
export const InviteResponseSchema = z.object({
    message: z.string(),
});
export const settingsContract = c.router({
    inviteUserToWorkspace: {
        method: 'POST',
        path: '/settings/invite',
        summary: 'Invite a user to a workspace',
        body: InviteUserToWorkspaceSchema,
        responses: {
            200: InviteResponseSchema,
            400: ApiErrorSchema,
            401: ApiErrorSchema,
            403: ApiErrorSchema,
            404: ApiErrorSchema,
        },
    },
    removeUserFromWorkspace: {
        method: 'DELETE',
        path: '/settings/members/:memberId',
        summary: 'Remove a member from the workspace',
        body: c.type(),
        responses: {
            200: InviteResponseSchema,
            401: ApiErrorSchema,
            404: ApiErrorSchema,
        },
    },
});
//# sourceMappingURL=settings.js.map